import * as SliderPrim from '@radix-ui/react-slider';
import clsx from 'clsx';

import classes from './styles.module.css';

export const Slider = ({ value, min, max, step, onChange, classNames }) => {
  return (
    <SliderPrim.Root
      className={clsx(classes.SliderRoot, classNames)}
      value={value}
      max={max}
      min={min}
      step={step}
      onValueChange={onChange}
    >
      <SliderPrim.Track className={classes.SliderTrack}>
        <SliderPrim.Range className={classes.SliderRange} />
      </SliderPrim.Track>
      <SliderPrim.Thumb className={classes.SliderThumb} />
    </SliderPrim.Root>
  );
};
